import {connect, ApplicationState} from '@modifi/redux'

import {aPush, selectSearchObj} from '@modifi/router'
import Shipments, {ShipmentsProps} from './Shipments'
import {
  selectShipments,
  aFetchShipments,
  selectShipmentsMeta,
  selectShipmentsWhereLoaded,
} from '../../data/shipments'
import {
  aRedirectWithDefaultQuery,
  selectKeyWindowFromSearchObject,
  selectFetchParamsFromSearchObject,
  aRedirectToShipmentsOverview,
  aShowErrorDialog,
  selectSubmitErrorObject,
} from './store'
import {aShowShipmentTrackingDetailsDialog} from '../../features/shipment-tracking-details/register'
import {aFetchUserSettings, aUpdateUserSettings, selectUserSettings} from '../../data/user-settings'

const mapStateToProps = (
  state: ApplicationState
): Pick<
  ShipmentsProps,
  | 'search'
  | 'shipments'
  | 'shipmentsWhereLoaded'
  | 'fetchParams'
  | 'shipmentsMeta'
  | 'userSettings'
  | 'errorObject'
> => {
  const keyWindow = selectKeyWindowFromSearchObject(state)
  const search = selectSearchObj(state)
  return {
    search,
    shipments: selectShipments(state, keyWindow),
    shipmentsWhereLoaded: selectShipmentsWhereLoaded(state, keyWindow),
    fetchParams: selectFetchParamsFromSearchObject(state),
    shipmentsMeta: selectShipmentsMeta(state, keyWindow),
    userSettings: selectUserSettings(state)?.emailNotifications,
    errorObject: selectSubmitErrorObject(state),
  }
}

const mapDispatchToProps = {
  fetchShipments: aFetchShipments,
  redirectWithDefaultQuery: aRedirectWithDefaultQuery,
  showDetails: aShowShipmentTrackingDetailsDialog,
  redirectToShipmentsOverview: aRedirectToShipmentsOverview,
  fetchUserSettings: aFetchUserSettings,
  updateUserSettings: aUpdateUserSettings,
  showErrorDialog: aShowErrorDialog,
  redirect: aPush,
}

export default connect(mapStateToProps, mapDispatchToProps)(Shipments)
